module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s03-3_s-40c4b1c48cdfca559bcd138f9e707478.png";